import { apiGet } from '@gat-ship/http-client'
import type { PortCallTypeRef } from '@gat-ship/types'

export async function getPortCallTypeRefsRequest() {
  return await apiGet<PortCallTypeRef[]>('ref-data/port-calls/types')
}
